import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Grid, Card, Divider, Checkbox, TextField, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import {
  GridToolbar,
  gridClasses,
  GridActionsCellItem,
  useGridApiRef,
  GridTreeDataGroupingCell,
  GridColDef,
} from "@mui/x-data-grid-pro";
import CopyRoleModal from "../copyRoleModal";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";
import { getSystemUsersDO } from "utils/systemUsersUtils";
import { getRolesDO,  updateRoleDo } from "utils/rolesUtils";
import { useMaterialUIController, setCurrentDialog, useAuth, useBrands } from "context";
import { TableColumnProps, TablePage } from "components/alove/TablePage";
import { BoRole, PermissionType } from "models/BO/BoRole";
import { element } from "prop-types";
import { PageNumber } from "accessNumbers";
import { RoleDialog } from "./AddNewRoleDialog";
import { DeleteRoleDialog } from "./DeleteRoleDialog";
import { DialogType } from "components/alove/AloveDialog";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import { AddGeneralCodeDialog } from "components/alove/AddGeneralCodeDialog";
import { GeneralCodeType } from "models/content/GeneralCode";
function ViewRoles() {
  const pageNumber = PageNumber.Roles;
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { currentUser, currentRole } = useAuth();
  const { currentBrand } = useBrands();
  const [refresh, setRefresh] = React.useState(false);
  const [role, setRole] = React.useState<BoRole | null>(null);


  const actionClick = (e, role: BoRole | null, dialogType: DialogType) => {
    e?.stopPropagation();
    setRole(role);
    setCurrentDialog(dispatch, dialogType)
  }


  const columns: TableColumnProps<BoRole>[] = [

    {
      field: "description",
      headerName: "Role Description",
      flex: 1,
    },
    {
      field: "isManager",
      headerName: "Type Manager",
      width: 150,
      type: "boolean",
      align: "center",
      hidden: (params) =>
        !currentRole?.hasAccess(pageNumber, PermissionType.Manager) || !currentBrand.isAlove,
      editable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      align: "center",
      renderCell: (params) => {
        if (Number.isInteger(params?.id)) {
          const actions: any[] = []; 
          if(currentRole?.hasAccess(pageNumber, PermissionType.Edit)){
            actions.push(
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                onClick={(e) => actionClick(e, params?.row, DialogType.EditRole)}
              />
            );
          }
          if(currentRole?.hasAccess(pageNumber, PermissionType.Delete)){
            actions.push(
              <GridActionsCellItem
                icon={<Delete />}
                label="Delete"
                onClick={(e) => actionClick(e, params?.row, DialogType.DeleteRole)}
                
              />
            );
          }
          return actions;
        } else {
          return [];
        }
      },
    },
  ];


  const prepareRows = async () => getRolesDO();



  const processRowUpdate = (newRow,oldRow) => {
    updateRoleDo(newRow, newRow.id);
    return newRow;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TablePage
        title={currentBrand?.name + " - Roles"}
        refresh={refresh}
        table={{
          columns,
          loadNext: prepareRows,
          lineClick: (params) => {
            if (Number.isInteger(params?.id)) {
              navigate(`/roles/${params?.id}`);
            }
          },
          processRowUpdate: processRowUpdate,
          getTreeDataPath: (row) => [row.type.name, row.roleName],
          groupingColDef: {
            minWidth: 300,
          },
        }}
        actions={{
          title: "Roles Actions",
          page: pageNumber,
          addActions: [
            {
              role: PermissionType.AddNew,
              label: "Role",
              variant: "contained",
              onClick: () => actionClick(null, null, DialogType.AddNewRole)
            },
            {
              label: "Role Type",
              role: PermissionType.Manager,
              onClick: () => setCurrentDialog(dispatch, DialogType.AddGeneralCode)
            },
            
            
          ]
        }}
      />
       <AddGeneralCodeDialog
        type={GeneralCodeType.RoleType}
        entity="Role Type" 
      /> 
       <DeleteRoleDialog roleId={role?.id} onDelete={() => setRefresh(!refresh)} />
      <RoleDialog role={role} onSubmit={() => setRefresh(!refresh)} /> 
    </DashboardLayout>
  );
}

export default ViewRoles;
